import { useComponentState } from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import Content from "src/components/Content";
import ContentOverview from "src/components/ContentOverview";
import Cta from "src/components/Cta";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import HeroBanner from "src/components/HeroBanner";
import HeroSlider from "src/components/HeroSlider";
import InstructorSlider from "src/components/InstructorSlider";
import InstructorStepper from "src/components/InstructorStepper";
import Logotypes from "src/components/Logotypes";
import ModalLogin from "src/components/ModalLogin";
import ModalNewPassword from "src/components/ModalNewPassword";
import Newsletter from "src/components/Newsletter";
import Page from "src/components/Page";
import Paragraph from "src/components/Paragraph";
import Platform from "src/components/Platform";
import Preloader from "src/components/Preloader";
import SubscriptionList from "src/components/SubscriptionList";
import Translate from "src/components/Translate";
import WhyToUse from "src/components/WhyToUse";
import constants from "src/constants";
import { UserContext, UserContextInterface } from "src/contexts/UserContext";
import HeroCalendar from "src/customs/HeroCalendar";
import HeroNFT from "src/customs/HeroNFT";
import getDefaultOg from "src/functions/getDefaultOg";
import gutter from "src/functions/gutter";
import translate from "src/functions/translate";
import { useFilters } from "src/functions/useFilters";
import useGetDataInstructors, {
  getDataInstructors,
} from "src/functions/useGetDataInstructors";
import useGetDataSeriesAndClasses, {
  getDataSeriesAndClasses,
} from "src/functions/useGetDataSeriesAndClasses";
import useLoggedInUser from "src/functions/useLoggedInUser";
import LogoCzechCrunch from "src/icons/Logo-czechcrunch";
import LogoFlexity from "src/icons/Logo-flexity";
import LogoJogaDnes from "src/icons/Logo-jogadnes";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sButton } from "src/styles/sButton.module.scss";
import { sCtaPlatformIntroduction } from "src/styles/sCtaPlatformIntroduction.module.scss";
import { sPageHome } from "src/styles/sPageHome.module.scss";
import { VariantColor } from "src/types/VariantColor";

const logotypesMedia = [
  {
    alt: "CzechCrunch",
    id: "czech-crunch",
    icon: <LogoCzechCrunch />,
    minWidth: "160px",
    path: constants.Paths.mediaCzecCrunch,
    tooltip: "Article – will be released by 2/3",
  },
  {
    alt: "JogaDnes",
    id: "joga-dnes",
    icon: <LogoJogaDnes />,
    minWidth: "115px",
    path: constants.Paths.mediaJogaDnes,
    tooltip: "Article",
  },
  {
    alt: "Flexity",
    id: "flexity",
    icon: <LogoFlexity />,
    path: constants.Paths.mediaFlexityPodcast,
    tooltip: "Podcast",
  },
];

export default function Homepage({
  staticLectures,
  staticPrograms,
  staticInstructors,
}) {
  const { locale: lang, push } = useRouter();

  const filtersState = useFilters();
  const seriesAndClassesResult = useGetDataSeriesAndClasses(
    filtersState.value,
    "",
    false,
    true
  );
  const dClassesList =
    seriesAndClassesResult.data?.lectures || staticLectures || [];
  const dSeriesList =
    seriesAndClassesResult.data?.programs || staticPrograms || [];

  const instructorsResult = useGetDataInstructors(lang, "", false, true);
  var dInstructorList =
    instructorsResult.data?.profiles || staticInstructors || [];

  const [alertMessage, setAlertMessage] = useState("");
  const [alertMessageStatus, setAlertMessageStatus] = useState<VariantColor>();
  const [alertMessageBtn, setAlertMessageBtn] = useState(false);
  const [alertNewPassword, setAlertNewPassword] = useState(false);
  let openModalLogin = useComponentState(false);
  let openModalRegister = useComponentState(false);
  let openModalNewPassword = useComponentState(false);
  var userResult = useLoggedInUser();
  const user: UserContextInterface = useContext(UserContext);

  useEffect(() => {
    let loginConfirm =
      window.location.href.indexOf("account=confirm") > -1 ? true : false;
    if (loginConfirm) {
      setAlertMessage("Email confirmation was successful. Now you can");
      setAlertMessageStatus("success");
      setAlertMessageBtn(true);
    }
    let loginConfirmFailed =
      window.location.href.indexOf("account=confirmFailed") > -1 ? true : false;
    if (loginConfirmFailed) {
      setAlertMessage(
        "Email confirmation was not successful. You may have clicked on the link before. Try to sign in."
      );
      setAlertMessageStatus("danger");
      setAlertMessageBtn(false);
    }
    if (window.location.href.indexOf("pwdCode") > -1) {
      openModalNewPassword.change(true);
    }
  }, [openModalNewPassword]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      // After 10 seconds set the show value to false
      setAlertNewPassword(false);
    }, 10000);

    return () => {
      clearTimeout(timeId);
    };
  }, [alertNewPassword]);

  return (
    <div id="root">
      <Headers data={getDefaultOg(lang)} />
      <Page className={composeClassNames([sPageHome, "page-home"])}>
        <Header />
        {alertMessage && !userResult.result && (
          <Alert
            variant={alertMessageStatus}
            className={composeClassNames([sAlert, "alert-flash"])}
          >
            <Translate tKey={alertMessage} />
            {alertMessageBtn && (
              <Button
                onClick={function () {
                  return openModalLogin.change(true);
                }}
                type="button"
                className={composeClassNames([sButton, "ml-2"])}
                variant="primary"
                size="sm"
              >
                <Translate tKey={`Sign in`} />
              </Button>
            )}
          </Alert>
        )}
        {alertNewPassword && (
          <Alert variant="success" className={sAlert}>
            <Translate
              tKey={`The password has been changed and the you are logged in.`}
            />
          </Alert>
        )}
        {/* TODO: context provider for modal login */}
        <ModalLogin
          openModalLogin={openModalLogin}
          openModalRegister={openModalRegister}
          key={`ModalLogin`}
        />
        <ModalNewPassword
          openModalNewPassword={openModalNewPassword}
          key={`ModalNewPassword`}
          setAlertNewPassword={setAlertNewPassword}
        />
        <HeroSlider>
          <HeroNFT />
          <HeroCalendar />
          <HeroBanner />
        </HeroSlider>
        <Cta
          button="Join the community"
          buttonClick={() => push("#subscription")}
          className={composeClassNames([
            sCtaPlatformIntroduction,
            "platform-introduction",
          ])}
          mediaPosition="left"
          mediaMobilePosition="bottom"
          text={
            "We believe that happiness and health begin with self-care. We are creating a place where you can find various tools to please the soul, strengthen the body and relax the mind. For a better life and a nicer world."
          }
          title={
            "Yoga, movement, therapy. All in one place; anytime and anywhere."
          }
          //secondButton="Share the app with others"
          //secondButtonClick={() => push(constants.Paths.joinUs)}
          sizeHeading="xl"
          sizeParagraph="md"
          videoSrc={
            {
              cs: constants.Paths.promoVideoCs,
              sk: constants.Paths.promoVideoSk,
              en: constants.Paths.promoVideoEn,
            }[lang]
          }
          videoSize="wide"
        />
        <Logotypes
          align="center"
          bgColor="primary"
          color="white"
          data={logotypesMedia}
          size="sm"
          showText={true}
          style={gutter(`padding`, `vertical`, `lg`)}
          description="Vivido in the media"
        />
        <Platform
          backgroundColor={constants.Theme.greyLightOpacity}
          specificContent="none"
          subtitle="Indulge your mental wellness with hundreds of online lessons and tailor-made programs with inspiring instructors and qualified therapists."
          title="Unique platform"
        />
        <Content fluid={`xxl`} verticalSpace={`lg`}>
          <ContentOverview
            series={dSeriesList}
            classes={dClassesList}
            primaryButton={{
              title: "Become a member",
              onClick: () => push("#subscription"),
            }}
          />
          {seriesAndClassesResult.loading &&
            (!seriesAndClassesResult.data ||
              seriesAndClassesResult.data.length === 0) && (
              <Paragraph align="center">
                <Preloader />
              </Paragraph>
            )}
        </Content>
        <WhyToUse
          backgroundColor={constants.Theme.greyLightOpacity}
          specificContent="none"
          subtitle="We ask the community for its needs and listen to what it says."
          title="Why use Vivido?"
        />
        <Content fluid={`full`} verticalSpace={`lg`}>
          <InstructorSlider
            data={dInstructorList}
            subtitle="Discover inspiring instructors and view their offer."
            title="Meet our instructors"
          />
          {instructorsResult.loading &&
            (!instructorsResult.data ||
              instructorsResult.data.length === 0) && (
              <Paragraph align="center">
                <Preloader />
              </Paragraph>
            )}
          <InstructorStepper style={gutter("margin", "top", "hg")} />
        </Content>
        <SubscriptionList
          backgroundColor={constants.Theme.greyLightOpacity}
          ctaBtnTitle={`Try for 1 CZK now!`}
        />
        <Cta
          title={
            "We are a group of yogis, webers and enthusiasts who want to make a difference"
          }
          text={
            "We have been in the world of yoga for some time, as well as in the development of web and mobile applications. We know how to build an applications you can rely on, so we decided to help the yoga community. In this way, instructors can focus on what they enjoy the most: yoga. They don't have to deal with the technology and bureaucracy around. And users-yogis can easily access interesting content."
          }
          videoSrc="https://youtu.be/RiEK6paBrY0"
          mediaPosition="right"
          button="Read full story"
          buttonClick={() => push("/story")}
          buttonSizes="nm"
          secondButton="Join the crew"
          secondButtonClick={() =>
            (window.location.href = translate(
              "mailto:team@vivido.fit?Subject=Join the Vivido crew&body=Hi,%0A%0AI would like to join the Vivido team.%0AI am interested in the following position: %0A%0ABest regards",
              lang
            ))
          }
        />
        <Newsletter backgroundColor={constants.Theme.secondary} />
        <Footer />
      </Page>
      <Footers />
    </div>
  );
}

export const getStaticProps: GetStaticProps = async function () {
  const { lectures, programs } = await getDataSeriesAndClasses();
  const instructors = await getDataInstructors();

  return {
    props: {
      staticLectures: lectures,
      staticPrograms: programs,
      staticInstructors: instructors,
    },
    revalidate: constants.Intervals.default,
  };
};
